import React, { useState } from 'react'
import t from 'prop-types'
import cx from 'classnames'
import { ReadingProgress } from '@makotot/ghostui'
import IconChevronRight from '../../Icons/IconChevronRight'

const ChapterHeading = ({ chapter, currentIndex, className, onClick }) => {
  currentIndex = currentIndex > 0 ? currentIndex : 1
  const isCurrent = Boolean(chapter?.index === currentIndex)

  return (
    <div
      className={cx(`${className} font-bold pt-3 pb-4`, {
        'opacity-100': isCurrent,
        'opacity-70 hover:opacity-100': !isCurrent,
      })}
    >
      <div className="uppercase text-white text-sans text-sm tracking-spacious">
        {chapter.label}&nbsp;{chapter.index}
      </div>
      <a
        className={cx(
          `font-serif font-semibold focus:text-blue-100 hover:underline text-lg leading-tight`,
          {
            'text-blue-200 hover:text-blue-100': isCurrent,
            'text-white hover:text-blue-100': !isCurrent,
          }
        )}
        href={chapter.href}
        onClick={evt => {
          onClick(evt, {
            scrollTarget: chapter.href,
            index: chapter.index,
          })
        }}
      >
        {chapter.text}
      </a>
    </div>
  )
}

const PillarStickyNav = ({
  chapters,
  currentIndex = 1,
  show = false,
  setShowNav = () => {},
}) => {
  const [menuOpen, setMenuOpen] = useState(false)

  const menuItemClick = (evt, data) => {
    document.getElementById(`chapter-${data.index}`).scrollIntoView(true)
    setMenuOpen(false)

    evt.preventDefault()
    return false
  }

  return (
    <nav
      className={cx(
        'pillar-sticky-nav fixed top-0 z-60 w-full max-w-page mx-auto transition-all duration-500 overflow-hidden',
        show && menuOpen ? 'max-h-screen' : show ? 'maxh-h-30' : 'max-h-0',
        show ? 'opacity-100' : 'opacity-0'
      )}
    >
      <div className="relative flex flex-row items-center bg-gray-700 min-h-22 w-full">
        <ChapterHeading
          currentIndex={currentIndex}
          chapter={chapters[currentIndex - 1]}
          className="w-full max-w-screen-md mx-auto pl-5 pr-16 lg:px-0"
          onClick={menuItemClick}
        />
        <button
          className={cx(
            'absolute right-0 transform transition-all duration-700 -translate-y-1/2 top-1/2 inline-flex w-3 h-5 mr-5 lg:mr-12 items-center justify-center',
            menuOpen ? 'rotate-90' : '-rotate-90'
          )}
          onClick={() => {
            setMenuOpen(!menuOpen)
          }}
        >
          <span className="sr-only">Open Chapter Nav</span>
          <IconChevronRight width={11} height={19} />
        </button>
        <ReadingProgress>
          {({ value }) => (
            <div className="w-full absolute bottom-0 h-1">
              <div
                className="bg-blue-300 h-full transition-all duration-1000"
                style={{
                  width: `${value}%`,
                }}
              ></div>
            </div>
          )}
        </ReadingProgress>
      </div>
      <div
        className={cx(
          'relative cursor-pointer overflow-hidden inline-block w-full h-auto transition-all duration-700',
          menuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
        )}
      >
        <menu className="list-none m-0 p-0 bg-black space-y-8 py-8">
          {chapters.map(chapter => {
            return (
              <li
                className={`${chapter.slug} text-white max-w-screen-md mx-auto px-5 lg:px-0`}
              >
                <ChapterHeading
                  chapter={chapter}
                  currentIndex={currentIndex}
                  onClick={menuItemClick}
                />
              </li>
            )
          })}
        </menu>
      </div>
    </nav>
  )
}

PillarStickyNav.propTypes = {
  chapters: t.array,
}

PillarStickyNav.defaultProps = {
  chapters: [],
}

export default PillarStickyNav
